// 가입 동의 화면(이용약관·개인정보·만 14세 이상)을 지났는지 이 탭에 30분 동안 적어 둔다.
// 가입 양식 화면은 이 표시가 없으면 동의 화면으로 돌려보낸다(주소로 바로 들어와 동의를 건너뛰지 않게, 10/19 처리방침).
const KEY = "lafiaJoinAgreed"
const KEEP_MS = 30 * 60 * 1000

export function markJoinAgreed() {
  try {
    window.sessionStorage.setItem(KEY, String(Date.now()))
  } catch (error) {}
}

export function hasJoinAgreed() {
  try {
    const at = Number(window.sessionStorage.getItem(KEY) || 0)
    return at > 0 && Date.now() - at < KEEP_MS
  } catch (error) {
    // 저장소를 못 쓰는 브라우저에서 가입을 막지 않는다
    return true
  }
}
